import type { Session } from "@supabase/supabase-js";
import { createContext } from "react";

import type { CurrentUser } from "../lib/types.js";

/**
 * Shape of the auth context.
 *
 * This lives apart from `AuthContext.tsx` so that file can export the provider
 * component and nothing else. React Fast Refresh can only swap a module whose
 * exports are all components; a context object sitting alongside the provider
 * forces a full reload on every edit to either.
 */
export interface AuthState {
  session: Session | null;
  user: CurrentUser | null;
  /** True until the initial session lookup settles, so guards can wait. */
  loading: boolean;
  isAdmin: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signUp: (
    email: string,
    password: string,
    displayName: string,
  ) => Promise<{ needsEmailConfirmation: boolean }>;
  signOut: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthState | null>(null);
